import { render, staticRenderFns } from "./RuleTemplatesModal.vue?vue&type=template&id=64d7523e"
import script from "./RuleTemplatesModal.vue?vue&type=script&lang=js"
export * from "./RuleTemplatesModal.vue?vue&type=script&lang=js"
import style0 from "./RuleTemplatesModal.vue?vue&type=style&index=0&id=64d7523e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports